/**
 * Client for the personal-data density ranking (release 8, C5). Wire shape
 * mirrors apps/api-controller/src/modules/discovery/store-density.ts.
 */

import { apiFetch } from './api';

export type DensitySort = 'density' | 'points' | 'columns';

export interface DenseStore {
  rank: number;
  assetId: string;
  assetRef: string;
  name: string;
  sourceType: string;
  sensitivity: string;
  businessUnitId: string | null;
  businessUnitName: string | null;
  rowCount: number | null;
  columnsKnown: number;
  personalColumns: number;
  classCount: number;
  /** 0 to 1. */
  density: number;
  dataPoints: number | null;
  /** The scans found personal data in this store, but no catalogued column carries a label. */
  unlabelled: boolean;
  lastScannedAt: string | null;
}

export interface DensityReport {
  asOf: string;
  sort: DensitySort;
  items: DenseStore[];
  truncated: boolean;
  totals: {
    measuredStores: number;
    unlabelledStores: number;
    unmeasuredStores: number;
    cataloguedStores: number;
    personalColumns: number;
    columnsKnown: number;
    /** Over EVERY catalogued store. */
    overallDensity: number | null;
  };
  basis: string;
}

export function getStoreDensity(p: { bu?: string; sort?: DensitySort; limit?: number } = {}): Promise<DensityReport> {
  const q = new URLSearchParams();
  for (const [k, v] of Object.entries(p)) {
    if (v !== undefined && v !== '') q.set(k, String(v));
  }
  const s = q.toString();
  return apiFetch(`/v1/discovery/store-density${s ? `?${s}` : ''}`);
}
